import React from 'react';

type Props = React.PropsWithChildren<{
  className?: string;
}>;

export const Header = ({ children, className }: Props): JSX.Element => {
  return <div className={['w-full', className].join(' ')}>{children}</div>;
};
